import { Component, Inject, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { ProposalItemService } from '../../../../core/services/proposal/proposal-item/proposal-item.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'

@Component({
  selector: 'modal-purchases-discount-itineraries',
  standalone: true,
  imports: [
    MatProgressBar,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIconModule,
  ],
  templateUrl: './modal-purchases-discount-itineraries.component.html',
  styleUrl: './modal-purchases-discount-itineraries.component.scss',
})
export class ModalPurchasesDiscountItinerariesComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalPurchasesDiscountItinerariesComponent>,
    private itinerariesService: ItinerariesService,
    private proposalItemService: ProposalItemService,
  ) {
    this.itemPropostaId = data?.itemPropostaId
    this.propostaId = data?.propostaId
    this.item = data?.item ?? {}
  }

  itemPropostaId: number
  propostaId: number
  item: any = {}
  loading = false
  listItineraries: any[] = []

  ngOnInit(): void {
    this.getItineraries()
    this.ensureObservacao()
  }

  // A observação é do item da proposta; o endpoint de detalhe (getProposalItembyId)
  // não a retorna, então buscamos pela lista de itens da proposta quando ausente.
  ensureObservacao() {
    if (this.item?.observacao || !this.propostaId || !this.itemPropostaId) {
      return
    }
    this.proposalItemService
      .listPagedProposalItemByProposal(this.propostaId, 1, 999)
      .subscribe({
        next: (response: any) => {
          const match = ((response?.data ?? []) as any[]).find(
            (it) => it.id === this.itemPropostaId,
          )
          if (match?.observacao) {
            this.item = { ...this.item, observacao: match.observacao }
          }
        },
        error: () => {},
      })
  }

  close() {
    this.dialogRef.close()
  }

  // Itinerário completo do item da proposta (Origem 'O', Paradas 'P', Destino 'D').
  getItineraries() {
    if (!this.itemPropostaId) {
      return
    }
    this.loading = true
    this.listItineraries = []
    this.itinerariesService
      .listPagedItinerariesByItemPropose(this.itemPropostaId, 1, 999)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          const list = (response?.data ?? []) as any[]
          const ordem = (t: string) => (t === 'O' ? 0 : t === 'D' ? 2 : 1)
          this.listItineraries = list.sort((a, b) => {
            const diff = ordem(a.trecho) - ordem(b.trecho)
            return diff !== 0 ? diff : (a.ordem ?? 0) - (b.ordem ?? 0)
          })
        },
        error: (err: ErrorRequestModel) => {
          console.error(err)
          this.listItineraries = []
        },
        complete: () => {
          this.loading = false
        },
      })
  }
}
